import { useEffect, useRef, useState } from "react";
import {
  faEllipsisVertical,
  faPlus,
  faTrash,
  faFileExport,
  faFileCsv,
  faUser,
  faMailForward,
  faPrint,
  faDownload,
  faBell,
  faAdd,
  faPhone,
  faStop,
  faCalendar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Dropdown,
  Nav,
  Container,
  Table,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  DeleteRequest,
  GetRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useGetRequest } from "../../Utils/hooks/QueryHandler";
import { Pagination } from "../../pages/Pagination";
import DeleteModal from "../DeleteModal";
import { toast } from "sonner";
import "./InvoiceOrder.css";
import {
  downloadPdf,
  formatDate,
  formatToINR,
  handleExportData,
  printPdf,
} from "../../Utils/helpers/commonhelper";
import InvoiceDetails from "./InvoiceDetails";
import { Filter } from "../../pages/Filter";
import { DropdownItemWithActions } from "../../pages/DropdownItemWithActions";
import { FilterPagination } from "../../pages/FIlterPagination";
import nodata from "../../Utils/assets/img/leads_no_data_found.png";
import { EmailModal } from "../detailPage/leads/EmailModal";
import { WhatsappModal } from "../../pages/WhatsappModal";
import { baseURL } from "../../Utils/constants/constant";
import { RxCrossCircled } from "react-icons/rx";
import { TableSkeleton } from "../../Utils/skeletonLoader/TableSkeleton";
import { UpgradePlan } from "../../pages/UpgradePlan";
import { AuthorizationCard } from "../../pages/AuthorizationCard";
import { ColumnConfigurator } from "../../pages/ColumnConfigurator";
import { ManageListDropdown } from "../../pages/ManageListDropdown";

export const InvoiceOrder = () => {
  const navigate = useNavigate();
  // state for show detail page

  const [customer, setCustomer] = useLocalStorageState("customer");

  const customer_id = customer?.customer_details?.customer_id || 1;
  const token = customer?.token?.authorization || "";
  const rf = customer?.token?.authentication || "";
  const extras = { customer, setCustomer, rf, navigate };
  const headers = {
    Authorization: token,
    Authentication: rf,
  };

  const [showInvoiceOrderDetails, setShowInvoiceOrderDetails] = useState(false);
  const [isMyApproval, setMyApproval] = useState(false);
  const [allSalesOrder, setAllSalesOrder] = useState([]);
  const [departmentToDelete, setDepartmentToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // delete modal loading state
  const [loading, setLoading] = useState(false);
  // States for using pagination
  // Calculate total pages

  const [limit, setLimit] = useState(25);
  const [offset, setOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [inputSearch, setInputSearch] = useState("");
  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearch(inputSearch.trim());
      setOffset(0);
    }, 300);
    return () => clearTimeout(debounceTimer);
  }, [inputSearch]);
  const params = {
    limit,
    offset,
    search: search,
  };

  const [endpoint, setEndpoint] = useState("");
  const [queryKey, setQueryKey] = useState("");

  // states to store the filter data
  const [filterStates, setFilterState] = useState([]);
  // lead owner state
  const [leadOwner, setLeadOwner] = useState([
    {
      leadName: "",
      leadId: "",
    },
  ]);
  // state for companies
  const [company, setCompany] = useState([]);
  // state for companies
  const [contacts, setContacts] = useState([]);

  const [heading, setHeading] = useState("All Invoice");
  // filter state to see the temoporary applied filter data,
  const [tempFilterData, setTempFilterData] = useState(null);
  // state for filter dropdown of quotations
  const [filterDropdown, setFilterDropdown] = useState(false);

  // for dropdown of the filter cards being created by the user
  const [filterCategoriesDropdown, setFilterCategoriesDrop] = useState(false);
  const filterCategoriesDropRef = useRef(null);

  // filter categories to render within the heading dropdown
  const [filterCategories, setFilterCategories] = useState([]);
  // filter seazrch bar input state
  const [filterSearchInput, setFilterSearchInput] = useState("");
  // Add states for filter pagination and search
  const [filterOffset, setFilterOffset] = useState(0);
  const filterLimit = (5);
  const [debouncedFilterSearch, setDebouncedFilterSearch] = useState("");
  const [filterPageCount, setFilterPageCount] = useState(0);
  // isediting state for undoing the edit state in the filter name update in the heading dropdown
  const [editingId, setEditingId] = useState(false);
  useEffect(() => {
    if (!filterSearchInput || filterSearchInput.trim() === "") {
      // If no search input, show all categories
      setFilteredCategories(filterCategories);
    } else {
      // Filter categories based on search input
      const filtered = filterCategories.filter((category) =>
        category.card_name
          .toLowerCase()
          .includes(filterSearchInput.toLowerCase())
      );
      setFilteredCategories(filtered);
    }
  }, [filterSearchInput, filterCategories]);
  // fitered categories to store the search input filter categories
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [openRow, setOpenRow] = useState(null);
  // filter state to store the data to pass to delete and edit handler for filter
  const [filterData, setFilterData] = useState(null);
  // edit value state fot the filter card name edit
  const [editValue, setEditValue] = useState();
  // delete state for filter
  const [confirmFilterDelete, setFilterDelete] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [invoiceIdToSend, setInvoiceIdToSend] = useState(null);
  const [invoiceData, setInvoiceData] = useState([]);
  // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
  const [isInitialized, setIsInitialized] = useState(false);

  // poermissions for invoice
  const permission = customer.customer_details?.permission;
  const isInvoice = permission?.find(c => c.module_name?.toLowerCase()?.split(" ")?.join("_") === "invoice")
  const invoicePermission = permission?.filter(c => c.module_name?.toLowerCase()?.split(" ")?.join("_") === "invoice")
  const user_type = Number(customer.customer_details?.user_type)
  const invoiceGrant = {
    isView: user_type !== 1 ? Boolean(Number(isInvoice && invoicePermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "invoice")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(isInvoice && invoicePermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "invoice")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(isInvoice && invoicePermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "invoice")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(isInvoice && invoicePermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "invoice")?.delete)) : true,
    isImport: user_type !== 1 ? Boolean(Number(isInvoice && invoicePermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "import")?.is_action)) : true,
    isExport: user_type !== 1 ? Boolean(Number(isInvoice && invoicePermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "export")?.is_action)) : true,
  }

  const invoiceStaticListOptions = [
    {
      key: "All Invoice",
      icon: <FontAwesomeIcon
        icon={faUser}
        style={{ width: "13px", height: "13px", marginRight: "9px" }}
      />
    }
  ]


  const invoiceOrderImportFields = [
    { id: "contact_id", label: "Contact", required: true },
    { id: "invoice_date", label: "Invoice Order Date", required: true },
    { id: "due_date", label: "Invoice Due Date", required: true },
    { id: "owner_id", label: "Company Account Owner", required: true },
    { id: "sales_id", label: "sales order", required: false },
    { id: "account_receivables", label: "Account Receviables (COA)", required: false },
    { id: "payment_terms", label: "Payment Terms", required: true },
    { id: "subject", label: "Short Description (email subject)", required: true },
    { id: "product", label: "Product", required: true },
    { id: "quantity", label: "Quantity", required: false },
    { id: "Rate", label: "Rate", required: false },
    { id: "gst", label: "GST", required: false },
    { id: "discount", label: "Discount", required: false },
    { id: "discountType", label: "Discount Type", required: false },
    { id: "itemDescription", label: "Description", required: false },
    { id: "amount", label: "Amount", required: false },
    { id: "discountedAmount", label: "Discounted Amount", required: false },
    { id: "sub-total", label: "Sub Total", required: true },
    { id: "grand_total", label: "Total", required: true },
    { id: "termsConditions", label: "Terms & Conditions", required: false },
    { id: "customerNote", label: "Customer Note", required: false },
  ]

  useEffect(() => {
    if (filterCategories?.length > 0 && !isInitialized) {
      const lastHeading = localStorage.getItem("quotation_last_heading");
      const existingFilter = filterCategories.find(
        (filter) => filter.card_name === lastHeading
      );
      setHeading(existingFilter ? lastHeading : "All Quotations");
      setIsInitialized(true);
    }
  }, [filterCategories, isInitialized]);

  //  filter dropdown options
  const dropdownOptions = [
    { value: "contact_id", label: "Contact", option: contacts },
    { value: "owner_id", label: "Owner", option: leadOwner },
    { value: "company_id", label: "Company Name", option: company },
    { value: "sale_no", label: "Sales Number" },
    { value: "invoice_date", label: "Invoice Date", type: "date-range" },
    { value: "due_date", label: "Due Date", type: "date-range" },
    { value: "invoice_number", label: "Invoice Number" },
    { value: "created_at", label: "Created at", type: "date-range" },
  ];

  // sub filter dropdown option
  const subFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "contains", label: "Contains" },
    { value: "not_contains", label: "Not-Contains" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
    { value: "is_empty", label: "Is Empty" },
    { value: "is_not_empty", label: "Is Not Empty" },
    { value: "begins_with", label: "Begins With" },
    { value: "between", label: "Between" },
  ];
  const customSubFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "is_set", label: "Is Set" },
    { value: "is_not_set", label: "Is Not Set" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
  ];

  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearch(inputSearch.trim());
      setOffset(0);
    }, 300);
    return () => clearTimeout(debounceTimer);
  }, [inputSearch]);

  // edit handler for filter heading
  const handleFilterEdit = async () => {
    try {
      if (editValue === "") return;
      if (filterData === null) return;
      const updatePayload = {
        customer_id: customer.customer_details?.customer_id,
        user_login_id: customer.customer_details?.id,
        filter_id: filterData.id,
        card_name: editValue,
        description: "",
      };
      const res = await PutRequest(
        "contacts/updateFilterName",
        updatePayload,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      );
      if (res.status === false || res.success === "fail") {
        setFilterDropdown(false);
        return;
      }
      if (res.status === "success") {
        setEditingId(null);
        fetchFilterCardCategories();
        setFilterDropdown(false);
      }
    } catch (error) {
      toast.error("Error Updating Filter");
    }
  };
  // delete handler for filter delete
  const handleFilterDelete = async () => {
    try {
      if (filterData === null) return;
      const res = await DeleteRequest(
        `common/deleteFilter/${filterData.id}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      );
      if (res.status === "fail") {
        toast.error(res.message);
        return;
      }
      if (res.success === false) {
        toast.error(res.message);
      }
      setFilterDropdown(false);
      setFilterDelete(false);
      setHeading("All Invoice");
      fetchFilterCardCategories();
      localStorage.setItem("invoice_last_heading", "All Invoice");
      toast.success(res.message);
    } catch (error) {
      toast.error("Error Deleting Filter");
    }
  };

  useEffect(() => {
    if (tempFilterData !== null) {
      setOffset(0);
    }
  }, [tempFilterData]);
  const handleFilterPageChange = (newOffset) => {
    setFilterOffset(newOffset.selected);
  };

  useEffect(() => {
    if (filterCategories?.length > 0 && !isInitialized) {
      const lastHeading = localStorage.getItem("invoice_last_heading");
      const existingFilter = filterCategories.find(
        (filter) => filter.card_name === lastHeading
      );
      setHeading(existingFilter ? lastHeading : "All Invoice");
      setIsInitialized(true);
    }
  }, [filterCategories, isInitialized]);

  // useeffect for lead owner
  useEffect(() => {
    (async () => {
      const res = await GetRequest(
        `users/users/fetchUserAsOwner/${customer.customer_details?.customer_id}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      );
      if (res.err) {
        // toast.error("Error Fetching Data");
        return;
      }
      const owners =
        res.data &&
        res.data?.map((lead) => ({
          leadName: lead.full_name,
          leadId: lead.id,
        }));
      setLeadOwner(owners);
    })();
  }, []);

  // useeffect for fetching contacts
  useEffect(() => {
    (async () => {
      try {
        const res = await GetRequest(
          `quotation/fetchContacts/${customer?.customer_details?.id}/${customer.customer_details.customer_id}/${customer?.customer_details?.user_type}`,
          { headers },
          extras
        );

        if (res.status !== "success") {
          return;
        }

        if (Array.isArray(res.data)) {
          const data = res.data?.map((contact) => {
            return {
              contact_name: contact.contact_full_name,
              contactId: contact.id,
            };
          });
          setContacts(data);
        }
      } catch (error) {
        toast.error("Something went wrong while fetching contacts");
      }
    })();
  }, []);

  // useeffect for fetching companies
  useEffect(() => {
    (async () => {
      const res = await GetRequest(
        `company/fetchCompanies/${customer.customer_details?.customer_id}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      );
      if (!res) return;
      if (res.success === false) {
        return;
      }
      setCompany(
        res.data?.map((c) => ({
          company_name: c.company_name,
          company_id: c.id,
        }))
      );
    })();
  }, []);

  // useeeffect for fetching the created advance filters
  const fetchFilterCardCategories = async () => {
    try {
      const res = await GetRequest(
        `common/fetchFilterCard/${customer.customer_details?.customer_id}/invoice?offset=${filterOffset}&limit=${filterLimit}&search=${debouncedFilterSearch}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      );

      if (res.status === "fail" || res.success === false) {
        return;
      }

      setFilterCategories(res.data);

      // Calculate page count if total_count is available in response
      if (res.total_count) {
        setFilterPageCount(Math.ceil(res.total_count / filterLimit));
      }
    } catch (error) {
      toast.error("Error fetching filters");
    }
  };
  useEffect(() => {
    fetchFilterCardCategories();
  }, [heading]);

  useEffect(() => {
    const lowerHeading = heading
      ? heading?.toLowerCase()?.split(" ").join("_")
      : heading;
    if (lowerHeading === "all_invoice") {
      setEndpoint(
        `invoice/fetchInvoice/${customer_id}/${customer?.customer_details?.id}/${customer?.customer_details?.user_type}`
      );
      setQueryKey(`fetchInvoice`);
    } else {
      // Set for filtered category
      const matchedCategory = filterCategories.find(
        (category) => category.card_name === heading
      );
      if (matchedCategory) {
        setEndpoint(
          `invoice/fetchInvoice/${customer_id}/${customer?.customer_details?.id}/${customer?.customer_details?.user_type}/${matchedCategory.id}`
        );
        setQueryKey(
          `filterQuery${matchedCategory.card_name
            .toLowerCase()
            ?.split(" ")
            .join("_")}`
        );
      }
    }
  }, [heading, filterCategories, isMyApproval]);

  // Single useGetRequest call
  const {
    data: salesOrderData,
    error,
    refetch: fetchSalesOrder,
    isLoading,
    isError,
  } = useGetRequest(
    endpoint,
    queryKey,
    headers,
    { customer, setCustomer, rf: headers.Authentication, navigate },
    params
  );

  // storing all contacts to a state to use it in the custom dropdown for the dynamic fields
  useEffect(() => {
    if (
      salesOrderData &&
      salesOrderData.filter_data &&
      salesOrderData.filter_data[0] &&
      salesOrderData.filter_data[0].filter_values
    ) {
      const values = salesOrderData.filter_data[0].filter_values;
      const parsedState = JSON.parse(values);
      const filteredArray = parsedState?.map((state) => {
        const dropdownOption = dropdownOptions.find(
          (opt) => opt.value === state.label_name
        );
        let mappedOptions = null;
        if (dropdownOption?.option && Array.isArray(dropdownOption.option)) {
          if (dropdownOption.value === "owner_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.id,
              label: opt.leadName,
            }));
          } else if (dropdownOption.value === "company_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.id,
              label: opt.company_name,
            }));
          } else if (dropdownOption.value === "contact_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.contactId,
              label: opt.contact_name,
            }));
          } else if (dropdownOption.value === "deal_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.id,
              label: opt.deal_name + " " + `(${opt.deal_no})`,
            }));
          }
        }
        return {
          id: state.label_name,
          field: state.label_name, // This is the internal identifier (e.g., "email", "owner")
          label_name: dropdownOption ? dropdownOption.label : state.label_name,
          option: mappedOptions,
          subFilterType: state.label_query,
          value:
            state.label_query === "between"
              ? { start: state.label_value[0], end: state.label_value[1] }
              : state.label_value,
        };
      });

      setFilterState(filteredArray);
    } else {
      setFilterState([]);
    }

    setAllSalesOrder(salesOrderData?.data);
    // setTotalCount(salesOrderData?.["total_count"])
  }, [queryKey, salesOrderData]);

  const dataToDisplay =
    tempFilterData !== null ? tempFilterData : allSalesOrder;
  const isFiltered = tempFilterData !== null;
  const pageCount = Math.ceil(
    (isFiltered
      ? (dataToDisplay?.length || 0)
      : (salesOrderData?.total_count || 0)
    ) / limit
  );

  const [detailPageId, setDetailPageId] = useState(null);
  // Handle page change from react-paginate
  const handlePageChange = (selectedItem) => {
    setOffset(selectedItem.selected);
  };

  const onDelete = (id) => {
    setDepartmentToDelete(id);
    setShowDeleteModal(true);
  };

  // Confirm delete and call API
  const handleConfirmedDelete = async () => {
    setLoading(true)
    try {
      const item = allSalesOrder.find((d) => d.id === departmentToDelete);

      const res = await DeleteRequest(
        `invoice/deleteInvoice/${departmentToDelete}/${customer_id}/${customer?.customer_details?.id}`,
        { headers },
        extras
      );

      if (res?.status === "success") {
        setLoading(false)
        toast.success(res.message);
        await fetchSalesOrder();
      } else if (res.status === "fail") {
        setLoading(false)
        toast.error(res.message);
      }
    } catch (error) {
      setLoading(false)
      console.error("Delete error:", error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
      setDepartmentToDelete(null);
    }
  };

  const handleDetailPageClicked = (saleOrder) => {
    setDetailPageId(saleOrder?.id);
    setShowInvoiceOrderDetails(true);
  };

  const columnOptions = [
    // { key: "sn", label: "#",locked: true },
    { key: "invoice_number", label: "Invoice Number", mandatory: true },
    { key: "sale_no", label: "Sales Number" },
    { key: "invoice_date", label: "Invoice Date" },
    { key: "contact_name", label: "Customer Name" },
    { key: "confirmed", label: "Payment" },
    { key: "items", label: "Amount" },
    { key: "due_amount", label: "Due Amount" },
    { key: "due_date", label: "Invoice Due Date" },
  ];

  // Initialize columns for the table - ALL columns visible by default
  const [columns, setColumns] = useState(() => {
    const saved = localStorage.getItem("visibleInvoiceColumns");
    const allColumnKeys = columnOptions?.map(col => col.label);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }
    return allColumnKeys;
  });

  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
    setInvoiceIdToSend(null);
    setInvoiceData([]);
  };

  const setStopReminder = async () => {
    try {
      const payload = {
        customer_id: customer_id,
        invoice_id: invoiceIdToSend?.id,
        reminder: "no",
      };
      const res = await PutRequest(
        `invoice/setReminder`,
        payload,
        { headers },
        extras
      );

      if (res.status === "fail" || res.status !== "success") {
        return toast.error(res.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setInvoiceIdToSend(null);
      setShowReminderModal(false);
    }
  };

  const handleAddPaymentClick = (saleOrder) => {
    const dataToSend = {
      key1: saleOrder?.id,
      key2: saleOrder?.contact_id,
      key3: saleOrder?.contact_name,
    };

    navigate("/createpayment", { state: dataToSend });
  };

  return (
    <>
      {
        !isInvoice &&
        <UpgradePlan moduleName="Invoice Order" />
      }
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmedDelete}
        isLoading={loading}
        message={"Are you sure you want to permanently delete this invoice?"}
      />

      {showEmailModal && (
        <EmailModal
          show={showEmailModal}
          onClose={handleCloseEmailModal}
          id={invoiceIdToSend}
          pipelineId={""}
          customerId={customer_id}
          loginId={customer?.customer_details?.id}
          headers={headers}
          extras={extras}
          data={invoiceData} // Pass lead data for pre-populating emails
          module_name={"invoice"}
        />
      )}

      {showWhatsappModal && (
        <WhatsappModal
          whatsappModalOpen={showWhatsappModal}
          setWhatsAppModalOpen={setShowWhatsappModal}
          id={invoiceIdToSend}
          module_name={"invoice"}
        />
      )}

      {showReminderModal && (
        <>
          <div
            className="modal  show fade d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content " style={{ marginTop: "120px" }}>
                <div className="modal-header d-flex justify-content-between">
                  <h5 className="modal-title">Stop Remender</h5>
                  <button
                    type="button"
                    className="btn"
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: "1.8rem",
                      cursor: "pointer",
                      color: "#888",
                      marginTop: "-20px",
                      opacity: "0.4",
                    }}
                    onClick={() => setShowReminderModal(false)}
                  >
                    <RxCrossCircled />
                  </button>
                </div>

                <div className="modal-body">
                  Are you sure you want to stop the reminder?
                </div>

                <div className="modal-footer" style={{ borderTop: "none" }}>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={() => {
                      setStopReminder();
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowReminderModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <div className=" pb-1 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <h3
            className="mb-0 d-flex gap-2 align-items-center"
            style={
              isMyApproval
                ? {
                  fontSize: 14,
                  cursor: "pointer",
                  textTransform: "capitalize",

                }
                : {
                  whiteSpace: "nowrap",
                  fontWeight: 300,
                  fontSize: "22px",
                  cursor: "pointer",
                  textTransform: "capitalize",
                  color: "#4dabf4"
                }
            }
            onClick={() => {
              setMyApproval(false);
            }}
          >
            {heading}
          </h3>

          <ManageListDropdown
            heading={heading}
            setHeading={setHeading}
            categories={filterCategories}
            storageKey="invoice_last_heading"
            setTempFilterData={setTempFilterData}
            onEdit={(c) => setFilterData(c)}
            onDelete={(c) => {
              setFilterData(c)
              setFilterDelete(true)
            }}
            onUpdate={(c) => {
              setFilterData(c)
              handleFilterEdit()
            }}
            staticOptions={invoiceStaticListOptions}
            filterOffset={filterOffset}
            setFilterOffset={setFilterOffset}
            handleFilterPageChange={handleFilterPageChange}
            filterPageCount={filterPageCount}
            filterLimit={filterLimit}
          />
          {confirmFilterDelete && (
            <DeleteModal
              show={confirmFilterDelete}
              onClose={() => setFilterDelete(false)}
              onConfirm={() => handleFilterDelete(filterData)}
              isLoading={loading}
              message={"Are you sure you want to delete this filter?"}
            ></DeleteModal>
          )}
        </div>

        <div
          className="d-flex align-items-center gap-1"
          style={{
            height: "35px",
            position: "absolute",
            right: 0,
            top: "0.5rem",
          }}
        >
          {/* search bar */}
          <div className=" position-relative">
            <input
              type="text"
              style={{
                fontSize: "12px",
                paddingLeft: "36px",
                height: "35px",
              }}
              className="form-control "
              value={inputSearch}
              onChange={(e) => {
                setInputSearch(e.target.value);
                setOffset(0);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  setSearch(inputSearch);
                  setOffset(0);
                }
              }}
            />
            <i
              class="fa-solid fa-magnifying-glass"
              style={{
                position: "absolute",
                marginTop: "-26px",
                zIndex: 1,
                marginLeft: "13px",
              }}
            ></i>
            {inputSearch?.length > 0 && (
              <i
                class="fa-solid fa-xmark"
                style={{
                  position: "absolute",
                  marginTop: "-26px",
                  zIndex: 1,
                  right: 0,
                  marginRight: "13px",
                  cursor: "pointer",
                }}
                onClick={() => setInputSearch("")}
              ></i>
            )}
          </div>
          {/* advance filtering */}
          <Filter
            canEdit_canDownload={true}
            filterDropdown={filterDropdown}
            setFilterDropdown={setFilterDropdown}
            dropdownOptions={dropdownOptions}
            filterState={filterStates}
            setFilterState={setFilterState}
            setHeading={setHeading}
            subFilter={subFilter}
            module_name={"invoice"}
            customSubFilter={customSubFilter}
            setTempFilterData={setTempFilterData}
            filterEndpoint={"common/filterQuery"}
            applyQuery={"invoice/applyFilter"}
            view="list"
          ></Filter>

          <ColumnConfigurator
            columnOptions={columnOptions}
            columns={columns}
            setColumns={setColumns}
            storageKey="invoiceColumns"
            visibleKey="visibleInvoiceColumns"
          />

          <Dropdown
            as="div"
            className="dropdownsWithoutToggle"
            style={{ zIndex: 101 }}
          >
            <Dropdown.Toggle as={Nav.Link} className="header-link">
              <button
                className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                style={{
                  fontSize: "1rem",
                  alignItems: "center",
                  height: "35px",
                  width: "2.5rem",
                }}
              >
                {" "}
                <FontAwesomeIcon
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                  icon={faEllipsisVertical}
                />
              </button>
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="defaultDropdown dropdown-menu-end "
              style={{ width: "11rem", padding: "12px 0px", right: "3.4rem" }}
            >
              <Dropdown.Item
                className="d-flex align-items-center"
                onClick={() => {
                  if (!invoiceGrant?.isExport) {
                    toast.warning("You are not authorized for this action!")
                    return
                  }
                  handleExportData([], "invoice_order", headers, extras)
                }}
              >
                <FontAwesomeIcon
                  icon={faFileExport}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginRight: "9px",
                    color: "#5e5f60",
                  }}
                />{" "}
                Export Data
              </Dropdown.Item>
              <Dropdown.Item href="#" className="d-flex align-items-center">
                <FontAwesomeIcon
                  icon={faFileCsv}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginRight: "9px",
                    color: "#5e5f60",
                  }}
                />{" "}
                Template
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Button
            type="button"
            className="btn btn-default"
            style={{
              maxHeight: "35px",
              color: "white",
              fontSize: "14px",
              border: "1px solid",
              alignItems: "center",
              paddingRight: "10px",
              backgroundColor: "rgb(122, 58, 94)",
            }}
            onClick={() => {
              if (!invoiceGrant?.isCreate) {
                toast.warning("You are not authorized for this action!")
                return
              }
              navigate("/createInvoiceOrder")
            }}
          >
            <FontAwesomeIcon icon={faPlus} /> Add
          </Button>
        </div>
      </div>

      {
        invoiceGrant?.isView ?
          <Container
            fluid
            style={{
              fontFamily: "'Poppins', sans-serif",
              height: "calc(100vh - 14rem)",
              padding: 0,
              backgroundColor: "white",
              animation: "cardEntry 1s ease-out forwards",
            }}
            className="mt-3 p-0"
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
              }}
            >
              <div
                className="listStyleForContact container-table"
                style={{
                  flex: dataToDisplay?.length > 10 ? 1 : "auto",
                  overflow: "auto",
                  width: "100%",
                  maxHeight: dataToDisplay?.length > 10 ? "100%" : "auto",
                  scrollbarWidth: "thin"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.scrollbarColor = "#e0e0e0 white"

                }}
              >
                <Table
                  style={{
                    width: "100%",
                    tableLayout: "auto",
                    backgroundColor: "white",
                    marginBottom: "0px",
                    borderCollapse: "separate",
                    borderSpacing: "0px",
                  }}
                >
                  <thead style={{ zIndex: 101 }}>
                    <tr>
                      <th
                        className="text-start  pinned-column last-pinned-column  bulk-selection-cell customize-cell-width"
                        style={{
                          width: 60,
                          minWidth: 60,
                          maxWidth: 60,
                          left: 0,
                        }}
                      >
                        <span>#</span>
                      </th>
                      {columns?.map((col, index) => (
                        <th
                          key={`header-${index}`}
                          style={{
                            textAlign:
                              col !== "Invoice Number" &&
                                col !== "Customer Name" &&
                                col !== "Sales Number"
                                ? "center"
                                : "left",
                          }}
                        >
                          {col}
                        </th>
                      ))}
                      <th></th>
                    </tr>
                  </thead>

                  <tbody style={{ textAlign: "start" }}>
                    {isLoading ? <TableSkeleton columnCount={columns?.length + 2} /> :
                      <>
                        {dataToDisplay !== null && dataToDisplay?.length == 0 ?
                          (
                            <td
                              colSpan="14"
                              style={{ textAlign: "center", color: "gray" }}
                            >
                              <div
                                class="d-flex justify-content-center align-items-center"
                                style={{ position: "absolute", left: " 42%" }}
                              >
                                <img
                                  src={nodata}
                                  alt=""
                                  style={{ width: "17rem", marginTop: "0" }}
                                />
                              </div>
                            </td>
                          )
                          :
                          (dataToDisplay?.map((saleOrder, index) => (
                            <tr key={saleOrder?.id || index}>
                              <td>{offset * limit + index + 1}</td>
                              {columns?.map((col, cellIndex) => {
                                switch (col) {
                                  case "Invoice Number":
                                    return (
                                      <td
                                        key={`cell-${index}-${cellIndex}`}
                                        onClick={() => handleDetailPageClicked(saleOrder)}
                                        style={{ color: "#0099ff", cursor: "pointer" }}
                                        data-bs-target="#saleOrderDetails"
                                        data-bs-toggle="offcanvas"
                                      >
                                        {saleOrder.invoice_number}
                                      </td>
                                    );

                                  case "Sales Number":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`}>
                                        {saleOrder.sale_no}{" "}
                                        <i className="fa-regular fa-envelope"></i>
                                      </td>
                                    );

                                  case "Invoice Date":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {formatDate(saleOrder.invoice_date)}
                                      </td>
                                    );

                                  case "Customer Name":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`}>
                                        {saleOrder.contact_name}
                                      </td>
                                    );

                                  case "Payment":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {(Number(JSON.parse(saleOrder.items)[0]?.["grand-total"]) || 0) -
                                          (Number(saleOrder?.payment_amount) || 0) !== 0 ? (
                                          <span style={{ color: "darkorange" }}>Pending</span>
                                        ) : (
                                          <span style={{ color: "darkgreen" }}>Paid</span>
                                        )}
                                      </td>
                                    );

                                  case "Amount":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {formatToINR(
                                          JSON.parse(saleOrder.items)[0]?.["grand-total"] || 0
                                        )}
                                      </td>
                                    );

                                  case "Due Amount":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {formatToINR(
                                          (Number(JSON.parse(saleOrder.items)[0]?.["grand-total"]) || 0) -
                                          (Number(saleOrder?.payment_amount) || 0)
                                        )}
                                      </td>
                                    );

                                  case "Invoice Due Date":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {formatDate(saleOrder?.due_date)}
                                      </td>
                                    );

                                  case "Due Date":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {formatDate(saleOrder?.due_date)}
                                      </td>
                                    );

                                  default:
                                    return <td key={`cell-${index}-${cellIndex}`}>-</td>;
                                }
                              })}
                              <td style={{ textAlign: "center" }}>
                                <div className="endTdDiv">
                                  <Dropdown
                                    as="div"
                                    className="dropdownsWithoutToggle"
                                  // onToggle={(isOpen) =>
                                  //   setOpenRow(isOpen ? saleOrder?.id : null)
                                  // }
                                  >
                                    <Dropdown.Toggle
                                      as={Nav.Link}
                                      className="header-link"
                                    >
                                      <FontAwesomeIcon
                                        className="text-muted"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                          color: "#536485",
                                        }}
                                        icon={faEllipsisVertical}
                                      />
                                      {/* </button> */}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu
                                      align={"end"}
                                      style={{
                                        width: "8rem",
                                        inset: "0px auto auto 0px",
                                        boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                                        position: "absolute",
                                        marginTop: "-22px",
                                        marginRight: "25px",
                                        minWidth: "3rem",
                                      }}
                                    >
                                      <Dropdown.Item
                                        href="#"
                                        className="d-flex align-items-center"
                                        onClick={() => {
                                          if (!invoiceGrant?.isDelete) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                          }
                                          onDelete(saleOrder.id)
                                        }}
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faTrash}
                                          style={{
                                            width: "16px",
                                            height: "16px",
                                            marginRight: "9px",
                                            color: "#5e5f60",
                                          }}
                                        />
                                        Delete
                                      </Dropdown.Item>

                                      <div className="endTdDiv">
                                        <Dropdown
                                          as="div"
                                          className="dropdownsWithoutToggle"
                                        >
                                          <Dropdown.Toggle
                                            as={Nav.Link}
                                            className="header-link"
                                            style={{
                                              marginLeft: "54%",
                                              fontSize: "14px",
                                            }}
                                          >
                                            <FontAwesomeIcon
                                              className="text-muted"
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                color: "#536485",
                                                marginRight: "9px",
                                              }}
                                              icon={faMailForward}
                                            />
                                            Send
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu
                                            align={"end"}
                                            style={{
                                              width: "8rem",
                                              inset: "0px auto auto 0px",
                                              boxShadow:
                                                "rgb(215, 215, 215) 0px 0px 15px",
                                              position: "absolute",
                                              marginTop: "-22px",
                                              marginRight: "25px",
                                              minWidth: "3rem",
                                            }}
                                          >
                                            <Dropdown.Item
                                              href="#"
                                              className="d-flex align-items-center"
                                              onClick={() => {
                                                setShowWhatsappModal(true);
                                                setInvoiceIdToSend(saleOrder?.id);
                                              }}
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                cursor: "pointer",
                                                fontSize: "14px",
                                                marginBottom: "9px",
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faPhone}
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  marginRight: "9px",
                                                  color: "#5e5f60",
                                                }}
                                              />
                                              WhatsApp
                                            </Dropdown.Item>

                                            <Dropdown.Item
                                              href="#"
                                              className="d-flex align-items-center"
                                              onClick={() => {
                                                setShowEmailModal(true);
                                                setInvoiceIdToSend(saleOrder?.id);
                                                setInvoiceData(saleOrder);
                                              }}
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faMailForward}
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  marginRight: "9px",
                                                  color: "#5e5f60",
                                                }}
                                              />
                                              Email
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>

                                      <div className="endTdDiv">
                                        <Dropdown
                                          as="div"
                                          className="dropdownsWithoutToggle"
                                        >
                                          <Dropdown.Toggle
                                            as={Nav.Link}
                                            className="header-link"
                                            style={{
                                              marginLeft: "54%",
                                              fontSize: "14px",
                                            }}
                                          >
                                            <FontAwesomeIcon
                                              className="text-muted"
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                color: "#536485",
                                                marginRight: "9px",
                                              }}
                                              icon={faPrint}
                                            />
                                            Print/PDF
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu
                                            align={"end"}
                                            style={{
                                              width: "8rem",
                                              inset: "0px auto auto 0px",
                                              boxShadow:
                                                "rgb(215, 215, 215) 0px 0px 15px",
                                              position: "absolute",
                                              marginTop: "-22px",
                                              marginRight: "25px",
                                              minWidth: "3rem",
                                            }}
                                          >
                                            <Dropdown.Item
                                              href="#"
                                              className="d-flex align-items-center"
                                              onClick={() => {
                                                printPdf(
                                                  `${baseURL}/invoice/downloadInvoice/${customer_id}/${saleOrder?.id}`,
                                                  headers,
                                                  "print"
                                                );
                                              }}
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                cursor: "pointer",
                                                marginBottom: "9px",
                                                fontSize: "14px",
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faPrint}
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  marginRight: "9px",
                                                  color: "#5e5f60",
                                                }}
                                              />
                                              Print
                                            </Dropdown.Item>

                                            <Dropdown.Item
                                              href="#"
                                              className="d-flex align-items-center"
                                              onClick={() => {
                                                downloadPdf(
                                                  `${baseURL}invoice/downloadInvoice/${customer_id}/${saleOrder?.id}`,
                                                  headers,
                                                  "download",
                                                  "invoice_order"
                                                );
                                              }}
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faDownload}
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  marginRight: "9px",
                                                  color: "#5e5f60",
                                                }}
                                              />
                                              PDF
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>
                                      <div className="endTdDiv">
                                        <Dropdown
                                          as="div"
                                          className="dropdownsWithoutToggle"
                                        >
                                          <Dropdown.Toggle
                                            as={Nav.Link}
                                            className="header-link"
                                            style={{
                                              marginLeft: "54%",
                                              fontSize: "14px",
                                            }}
                                          >
                                            <FontAwesomeIcon
                                              className="text-muted"
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                color: "#536485",
                                                marginRight: "9px",
                                              }}
                                              icon={faBell}
                                            />
                                            Reminder
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu
                                            align={"end"}
                                            style={{
                                              width: "8rem",
                                              inset: "0px auto auto 0px",
                                              boxShadow:
                                                "rgb(215, 215, 215) 0px 0px 15px",
                                              position: "absolute",
                                              marginTop: "-22px",
                                              marginRight: "25px",
                                              minWidth: "3rem",
                                            }}
                                          >
                                            <Dropdown.Item
                                              href="#"
                                              className="d-flex align-items-center"
                                              onClick={() => {
                                                setShowReminderModal(true);
                                                setInvoiceIdToSend(saleOrder?.id);
                                              }}
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                cursor: "pointer",
                                                marginBottom: "9px",
                                                fontSize: "14px",
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faStop}
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  marginRight: "9px",
                                                  color: "#5e5f60",
                                                }}
                                              />
                                              Stop
                                            </Dropdown.Item>

                                            <Dropdown.Item
                                              href="#"
                                              className="d-flex align-items-center"
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faCalendar}
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  marginRight: "9px",
                                                  color: "#5e5f60",
                                                }}
                                              />
                                              Follow
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>
                                      <Dropdown.Item
                                        href="#"
                                        className="d-flex align-items-center"
                                        onClick={() => {
                                          if (!invoiceGrant?.isCreate) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                          }
                                          handleAddPaymentClick(saleOrder);
                                        }}
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                          cursor: "pointer",
                                          marginTop: "4px",
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faAdd}
                                          style={{
                                            width: "16px",
                                            height: "16px",
                                            marginRight: "9px",
                                            color: "#5e5f60",
                                          }}
                                        />
                                        Payment
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </td>
                            </tr>
                          )))
                        }
                        {dataToDisplay?.length > 10 && (
                          <tr
                            className="no-hover-row"
                            style={{
                              backgroundColor: "#ffffff",
                              marginTop: "0px !important",
                              marginBottom: "0px !important",
                            }}
                          >
                            <td colSpan={12}>
                              <div style={{ padding: 0 }}>
                                <div
                                  className="d-flex justify-content-between align-items-center gap-2 mt-0"
                                  style={{
                                    padding: "0.5rem 0",
                                  }}
                                >
                                  <div className="pagination-left">
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: "14px",
                                        paddingRight: "10rem",
                                      }}
                                    >
                                      Showing {offset + 1} of{" "}
                                      {pageCount !== 0 ? pageCount : pageCount + 1}
                                    </p>
                                  </div>
                                  <div className="pagination-right d-flex gap-2 align-items-center">
                                    <select
                                      style={{ minWidth: "78px", height: "2.3rem" }}
                                      onChange={(e) => {
                                        setLimit(Number(e.target.value));
                                        setOffset(0);
                                      }}
                                      id="limit"
                                      className="form-control form-select"
                                    >
                                      <option value={25}>25</option>
                                      <option value={100}>100</option>
                                      <option value={200}>200</option>
                                      <option value={300}>300</option>
                                    </select>
                                    <div className="d-flex align-items-center gap-3">
                                      <Pagination
                                        offset={offset}
                                        setOffset={setOffset}
                                        handlePageChange={handlePageChange}
                                        pageCount={pageCount}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </>
                    }
                  </tbody>
                </Table>
              </div>
              {dataToDisplay?.length <= 10 && (
                <div
                  style={{
                    padding: "0.5rem 0",
                    backgroundColor: "white",
                    borderTop: "1px solid #e0e0e0",
                    width: "100%",
                    overflowX: "auto",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center gap-2">
                    <div className="pagination-left">
                      <p className="mb-0" style={{ fontSize: "14px" }}>
                        Showing {offset + 1} of{" "}
                        {pageCount !== 0 ? pageCount : pageCount + 1}
                      </p>
                    </div>
                    <div className="pagination-right d-flex gap-2 align-items-center">
                      <select
                        style={{ minWidth: "78px", height: "2.3rem" }}
                        onChange={(e) => {
                          setLimit(Number(e.target.value));
                          setOffset(0);
                        }}
                        id="limit"
                        className="form-control form-select"
                      >
                        <option value={25}>25</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                        <option value={300}>300</option>
                      </select>
                      <div className="d-flex align-items-center gap-3">
                        <Pagination
                          offset={offset}
                          setOffset={setOffset}
                          handlePageChange={handlePageChange}
                          pageCount={pageCount}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* {console.log("editData", editData)} */}
            {showInvoiceOrderDetails && (
              <InvoiceDetails
                show={showInvoiceOrderDetails}
                setShowSalesOrderDetails={setShowInvoiceOrderDetails}
                detailPageId={detailPageId}
                handleClose={() => setShowInvoiceOrderDetails(false)}
              />
            )}
          </Container>
          :
          <AuthorizationCard></AuthorizationCard>
      }
    </>
  );
};
